import { type FunctionComponent } from 'react';
import { PLACEHOLDER_OPTIONS } from '../../../../constants/cloudinary/general';
import { type CloudinaryOptions } from '../../../../helpers/cloudinary-helper/cloudinary-helper';
import { type HomePageCarouselItem } from '../../../../helpers/home/home-carousel/home-carousel.helpers';
import { LinkButton } from '../../../buttons/link-button/link-button.component';
import { Link } from '../../../common-components/link/link.component';
import { CloudinaryImage } from '../../../images/cloudinary-image/cloudinary-image.component';
import { isTipsAndInspirationItem } from '../../home-common.helpers';

export type TipsInspirationSlideProps = {
	item: HomePageCarouselItem;
};

export const TipsInspirationSlide: FunctionComponent<TipsInspirationSlideProps> = ({ item }) => {
	if (!isTipsAndInspirationItem(item)) return;

	const { name, url, tracking } = item.trackingLink;
	const options: CloudinaryOptions = { height: 794, width: 420, crop: 'mfit' };
	return (
		<div className="flex flex-column self-start justify-end theme-black w-auto relative" data-testid="tips-inspiration-slide">
			<div className="absolute z-1 bg-theme-white ph3 pb3 ba b--theme-grey-light w-100">
				<h3 className="f4 font-light lh-title pt2 ma0">{item.title}</h3>
				<span className="f6">{item.subtitle}</span>
				<div className="flex flex-row items-end justify-between mt3">
					<LinkButton url={url} buttonStyle="SECONDARY" size="SMALL" analyticsHook={tracking}>
						Read
					</LinkButton>
				</div>
			</div>
			<Link url={url} analyticsHook={tracking} ariaLabel={name}>
				<CloudinaryImage
					publicID={item.image.id}
					description={item.image.description}
					options={options}
					useDimensions={false}
					placeholderOptions={{
						...options,
						...PLACEHOLDER_OPTIONS
					}}
					lowQualityPlaceholder={item.image.lowQualityPlaceholder}
				/>
			</Link>
		</div>
	);
};
